import {useState} from 'react';
import {InputNumber, Modal} from 'antd';
import {CategoryType} from "../../api/Constants";
import {lbsToGrams, GRAMS_PER_LB, fixedToDisplayUnit} from "../../util/unitutils";

export const PriceEntryWidget = ({item, onPriceChange, props}) => {
    const displayQuantity = fixedToDisplayUnit(item.quantity, item.unit);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [priceVal, setPriceVal] = useState(item.linePrice / displayQuantity);
    const [lineVal, setLineVal] = useState(item.linePrice)

    const onClick = () => {
        setIsModalOpen(true);
    }

    const onModalCancel = () => {
        setIsModalOpen(false);
    }

    const onModalOk = () => {
        if (onPriceChange) {
            onPriceChange(lineVal);
        }
        setIsModalOpen(false);
    }

    const onPriceValChange = (val) => {
        setPriceVal(val);

        setLineVal(val * displayQuantity);
    }

    const onLbsPriceChange = (val) => {
        const pricePerGram = val / GRAMS_PER_LB;
        console.log(`${pricePerGram} ${typeof pricePerGram}`)
        setPriceVal(pricePerGram);
        setLineVal(pricePerGram * displayQuantity);
    }

    const onTotalPriceChange = (val) => {
        const pricePerUnit = val / displayQuantity;
        console.log(`pricePerUnit ${pricePerUnit}`);

        setPriceVal(pricePerUnit);
        setLineVal(val);
    }

    const displayPrice = (item.linePrice === undefined) ? "$ 0.00" : `$ ${item.linePrice}`

    const unitLabel = (item.category === CategoryType.Wholesale) ? "/ g" : "/ unit"

    return <div>
        <div onClick={onClick} style={{cursor: 'pointer', color:"#108ee9", margin: "5px"}}>{displayPrice}</div>
        <Modal open={isModalOpen} onCancel={onModalCancel} onOk={onModalOk}>
            <b>{displayQuantity}{(item.category === CategoryType.Wholesale) ? " g": ""} {item.name}</b><p/>
            <InputNumber style={{width: 200}} placeholder={"price"} addonBefore={"$"} addonAfter={unitLabel} onChange={onPriceValChange} precision={2} min={0} value={priceVal} />
            <p/>
            {item.category === CategoryType.Wholesale &&
            <InputNumber placeholder={"price"} addonBefore={"$"} addonAfter={"/ lb"} onChange={onLbsPriceChange} precision={2} min={0} value={lbsToGrams(priceVal)} />
            }
            <p/>
            <InputNumber style={{width: 200}} placeholder={"total price"} addonBefore={"$"} addonAfter={`Total`} onChange={onTotalPriceChange} precision={2} min={0} value={lineVal} />
        </Modal>
    </div>
}